import React from "react";
import { UseFormReturn } from "react-hook-form/dist/types/form";
import { useTranslation } from "react-i18next";
import { FormCheck, FormInput } from "go-form";
import { ApplicationUpdateApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<ApplicationUpdateApi>;
}

const CallRecorderForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		formState: { errors },
		register,
	} = form;

	return (
		<>
			<FormInput label={t("lib:common.word.name")} register={register} name="name" errors={errors} />
			<FormCheck
				register={register}
				name="settings.persist_outgoing_calls"
				type="switch"
				errors={errors}
				label={t("modules.app.field.persist_outgoing_calls.title")}
			/>
			<FormCheck
				register={register}
				name="settings.persist_missed_calls"
				type="switch"
				errors={errors}
				label={t("modules.app.field.persist_missed_calls.title")}
			/>
		</>
	);
};

export default CallRecorderForm;
